import styles from "./styles.module.css";
import { useEffect, useState } from "react";

import { database, storage } from "../../../services/firebase-config";
import { addDoc, updateDoc, doc, collection, getDocs } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"

import InputText from "../../Form/InputText";
import InputDouble from "../../Form/InputDouble";
import InputFileBook from "../../Form/InputFileBook";
import InputSelect from "../../Form/InputSelect";
import InputTextArea from "../../Form/InputTextArea";
import InputFileImage from "../../Form/InputFileImage";
import Loading from "../../Loading";
import AlertModal from "../../Layout/AlertModal";
import InputCheckBox from "../../Form/InputCheckBox";

export default function ModalCreateUpdateBook({ setModalVisible, collectionRef, update, bookId, isVirtual, updateTableData }) {

    const [selectCategories, setSelectCategories] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [alertModal, setAlertModal] = useState(false);
    const [alertModalTitle, setAlertModalTitle] = useState('Alert');
    const [alertModalMessage, setAlertModalMessage] = useState('Alert Message');


    const [title, setTitle] = useState(bookId ? bookId.name ? bookId.name : '' : '');
    const [author, setAuthor] = useState(bookId ? bookId.author ? bookId.author : '' : '');
    const [image, setImage] = useState(bookId ? bookId.image ? bookId.image : '' : '');
    const [price, setPrice] = useState(bookId ? bookId.price ? bookId.price : 0 : 0);
    const [discount, setDiscount] = useState(bookId ? bookId.discount ? bookId.discount : 0 : 0);
    const [category, setCategory] = useState(bookId ? bookId.categories ? bookId.categories : [] : []);
    const [gender, setGender] = useState(bookId ? bookId.gender ? bookId.gender : '' : '');
    const [isbn, setIsbn] = useState(bookId ? bookId.isbn ? bookId.isbn : '' : '');
    const [pageQuantity, setPageQuantity] = useState(bookId ? bookId.pages ? bookId.pages : 0 : 0);
    const [publisher, setPublisher] = useState(bookId ? bookId.publishing_company ? bookId.publishing_company : '' : '');
    const [synopsis, setSynopisis] = useState(bookId ? bookId.synopsis ? bookId.synopsis : '' : '');
    const [bookFile, setBookFile] = useState(bookId ? bookId.file_download_link ? bookId.file_download_link : '' : '');



    useEffect(() => {
        const getCategories = async () => {
            const categoriesCollectionRef = collection(database, 'categories');
            const data = await getDocs(categoriesCollectionRef);
            const dataArray = [];

            data.docs.forEach((doc) => {
                if (doc.data().active) {
                    dataArray.push(doc.data());
                }
                setSelectCategories(dataArray);
            })

            console.log("getFirebaseData");
        }
        getCategories();

    }, []);

    function handleCategoryChange(event, catData) {
        console.log(event.target.checked);
        let count = 0;
        let flagAdd = 0;
        const newCategories = category;
        newCategories.forEach((c) => {
            if (c.id === catData.id) {
                newCategories.splice(count, 1);
                flagAdd++
            }
            count++;
        })
        if (flagAdd === 0) {
            newCategories.push({ id: catData.id, name: catData.name });
            setCategory([]);
            setCategory(newCategories);
        }
        setCategory(newCategories);
        console.log(category);
    }

    function checkFormFields() {
        if (title === null || title === undefined || title === '') {
            setIsLoading(false);
            setAlertModalTitle('Erro');
            setAlertModalMessage('O campo Título não pode estar vazio');
            setAlertModal(true);
            setTimeout(() => {
                setAlertModal(false);
            }, 3000)
            return false;
        }
        if (price === null || price === undefined || price <= 0) {
            setIsLoading(false);
            setAlertModalTitle('Erro');
            setAlertModalMessage('O campo preço deve possuir um valor maior que 0');
            setAlertModal(true);
            setTimeout(() => {
                setAlertModal(false);
            }, 3000)
            return false;
        }
        if (discount === null || discount === undefined || discount < 0 || discount > 100) {
            setIsLoading(false);
            setAlertModalTitle('Erro');
            setAlertModalMessage('O campo desconto deve possuir um valor entre 0 e 100');
            setAlertModal(true);
            setTimeout(() => {
                setAlertModal(false);
            }, 3000)
            return false;
        }
        if (pageQuantity === null || pageQuantity === undefined || pageQuantity <= 0) {
            setIsLoading(false);
            setAlertModalTitle('Erro');
            setAlertModalMessage('O campo quantidade de páginas deve possuir um valor maior que 0');
            setAlertModal(true);
            setTimeout(() => {
                setAlertModal(false);
            }, 3000)
            return false;
        }
        if (isVirtual) {
            if (!update) {
                if (bookFile === null || bookFile === undefined || bookFile === '') {
                    setIsLoading(false);
                    setAlertModalTitle('Erro');
                    setAlertModalMessage('O campo de arquivo .epub não pode estar vazio');
                    setAlertModal(true);
                    setTimeout(() => {
                        setAlertModal(false);
                    }, 3000)
                    return false;
                }
            }
        }
        return true;
    }


    async function updateBook(event) {
        event.preventDefault();
        setIsLoading(true);

        const isValidate = checkFormFields();
        if (!isValidate) {
            return (console.error("Error: Field Required"))
        }

        const collectionName = collectionRef;


        let imageUrl = '';
        let bookFileUrl = '';

        if (image.name) {
            const storageImageRef = ref(storage, `images/${collectionName}/${bookId.id}`);
            await uploadBytes(storageImageRef, image);
            imageUrl = await getDownloadURL(storageImageRef);
        }
        else {
            imageUrl = image;
        }
        if (isVirtual) {
            if (bookFile.name) {
                const storageBookRef = ref(storage, `${collectionName}/${bookId.id}.${bookFile.name.split('.').pop()}`);
                await uploadBytes(storageBookRef, bookFile);
                bookFileUrl = await getDownloadURL(storageBookRef);
            }
            else {
                bookFileUrl = bookFile;
            }
        }

        let updateData = {}

        if (isVirtual) {
            updateData = {
                author: author,
                categories: category,
                discount: discount,
                gender: gender,
                isbn: isbn,
                name: title,
                pages: pageQuantity,
                price: price,
                publishing_company: publisher,
                synopsis: synopsis,
                image: imageUrl,
                file_download_link: bookFileUrl,
                active: true
            }
        }
        else {
            updateData = {
                author: author,
                categories: category,
                discount: discount,
                gender: gender,
                isbn: isbn,
                name: title,
                pages: pageQuantity,
                price: price,
                publishing_company: publisher,
                synopsis: synopsis,
                image: imageUrl,
                active: true
            }
        }

        const docRef = doc(database, collectionRef, bookId.id);
        updateDoc(docRef, updateData)

        setModalVisible(false)
        setIsLoading(false);
        updateTableData();
    }


    async function createBook(event) {
        event.preventDefault();
        setIsLoading(true);

        const isValidate = checkFormFields();
        if (!isValidate) {
            return (console.error("Error: Field is Required"))
        }

        const newDoc = await addDoc(collectionRef, {
            author: author,
            categories: category,
            discount: discount,
            gender: gender,
            isbn: isbn,
            name: title,
            pages: pageQuantity,
            price: price,
            publishing_company: publisher,
            synopsis: synopsis,
            active: true
        });

        const collectionName = collectionRef.id;

        let imageUrl = 'https://i.pinimg.com/736x/28/03/4e/28034e601b054650d3a70e382db80b44.jpg';
        if (image) {
            const storageImageRef = ref(storage, `images/${collectionName}/${newDoc.id}`);
            await uploadBytes(storageImageRef, image);
            imageUrl = await getDownloadURL(storageImageRef);
        }

        let bookFileUrl = ''
        if (isVirtual) {
            if (bookFile) {
                const storageBookRef = ref(storage, `${collectionName}/${newDoc.id}.${bookFile.name.split('.').pop()}`);
                await uploadBytes(storageBookRef, bookFile);
                bookFileUrl = await getDownloadURL(storageBookRef);
            }
        }

        if (isVirtual) {
            updateDoc(newDoc, { id: newDoc.id, image: imageUrl, file_download_link: bookFileUrl })
        }
        else {
            updateDoc(newDoc, { id: newDoc.id, image: imageUrl })
        }

        setModalVisible(false);
        setIsLoading(false);
        updateTableData();
    }


    return (
        <div className={styles.fixed}>
            <div className={styles.modalContainer}>
                {alertModal && <AlertModal title={alertModalTitle} message={alertModalMessage} />}


                <div className={styles.modalCard}>
                    {isLoading && <Loading />}
                    <h2>{update ? "Atualizar" : "Cadastrar"}</h2>
                    <form >
                        <div className={styles.modalCard__formFields}>
                            <div className={styles.formFields__column}>
                                <InputText value={title} name="Título do livro" setValue={setTitle} type="text" />
                                <InputText value={author} name="Autor" setValue={setAuthor} type="text" />
                                <InputFileImage value={image} setValue={setImage} bookData={bookId} />
                            </div>

                            <div className={styles.formFields__column}>

                                <InputDouble>
                                    <InputText value={price} name="Preço (R$)" setValue={setPrice} type="number" />
                                    <InputText value={discount} name="Desconto (%)" setValue={setDiscount} type="number" />
                                </InputDouble>

                                <InputDouble>
                                    <div className={styles.formFields__categoriesCheckboxContainer}>
                                        <span>Categorias</span>
                                        {selectCategories.map((cat) => {
                                            return (
                                                <InputCheckBox key={cat.id} allData={category} data={cat} handleCategoryChange={handleCategoryChange} />
                                            )
                                        })}
                                    </div>
                                    <InputText value={gender} name="Gênero" setValue={setGender} type="text" />
                                </InputDouble>

                                <InputText value={isbn} name="ISBN" setValue={setIsbn} type="text" />
                                <InputText value={pageQuantity} name="Quantidade de páginas" setValue={setPageQuantity} type="number" />
                                <InputText value={publisher} name="Editora" setValue={setPublisher} type="text" />
                                <InputTextArea name="Sinopse" value={synopsis} setValue={setSynopisis} />
                            </div>
                        </div>
                        {isVirtual && <InputFileBook value={bookFile} setFile={setBookFile} />}
                        <div className={styles.buttonsContainer}>
                            <button onClick={() => { setModalVisible(false) }} className={styles.modalCard__closeButton} >Fechar</button>
                            {update ?
                                <button onClick={(event) => { updateBook(event) }} className={styles.modalCard__saveButton}>Atualizar</button>
                                :
                                <button onClick={(event) => { createBook(event) }} className={styles.modalCard__saveButton}>Cadastrar</button>
                            }
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}